import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { Redirect } from "react-router";
import React from "react";
import { getFromEncLocalStorage, sleep } from "../helpers/Utils/Utils";
import axios from "axios";
import {
  checkDoc,
  conversionProgress,
  startVideoProcess,
  uploadBigVideo,
} from "../helpers/API/APIEndPoints";
import Resumable from "resumablejs";
import moment from "moment";
import { APICall } from "../helpers/API/APICalls";
import { vi } from "date-fns/locale";

export const videoApi = async (url, { method, headers, payload }) => {
  // if (payload?.hasOwnProperty("payload")) {
  //   headers = { ...headers, "Content-Type": "multipart/form-data" };
  // }
  // const response = await fetch(url, {
  //   method,
  //   headers: {
  //     ...headers,
  //   },
  //   body: payload,
  // });

  // const data = await response.json();
  // console.log("videoApi response: ", response);
  // // console.log("data: ", data);
  // if (response.status == 403) {
  //   localStorage.clear();
  //   return <Redirect to="/" />;
  // } else if (response.status != 200) {
  //   return false;
  // } else {
  //   return data;
  // }

  return false;
};

export const createKnowledge = async (formData) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.createKnowledgeApi, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    payload: formData,
    //isFormData: true,
  });
  return data;
};

export const fileUpload = async (fileData, container) => {
  let data = [];

  try {
    // data = await fetch(
    //   // "https://azure-storage.herokuapp.com/azure/uploadBlob",
    //   `https://mobilityservices.mahindra.com/azure/v2/uploadBlob`,
    //   // `https://e302-103-137-155-69.ngrok.io/azure/uploadBlob`,
    //   {
    //     method: "post",
    //     body: fileData,
    //     headers: {
    //       containername: container,
    //       accountname: "kmsmediasvcstorage",
    //       // accountkey:
    //       //   "swGuYdk3eOgKPhi6ZHdwDzb5SeZBh9l3+hSdJ+RqOTYQ4YPLuisM8ZMykUpK/X2LkCFKDqxm7yndU5iasiJ/3Q==",
    //     },
    //   }
    // );

    data = await axios.request({
      url: `https://mobilityservices.mahindra.com/azure/v2/uploadBlob`,
      method: "POST",
      headers: {
        containername: container,
        accountname: "kmsmediasvcstorage",
      },
      data: fileData,
    });
  } catch (err) {
    console.log("error in uploading blob: ", err);
    data = err;
  }

  console.log("fileUpload data: ", data);
  // console.log("fileUpload data.json() : ", data.json());

  return data.data;

  // let resp = data.json();

  // return resp;
};

// export const getFile = async (container) => {
//   const data = await videoApi(
//     // `https://mobilityservices.mahindra.com/azure/getBlob`,
//     "https://6f51-103-137-155-55.ngrok.io/azure/uploadBlob",
//     {
//       method: "POST",

//       headers: {
//         //"Content-Type": "application/json",
//         accountname: "kmsmediasvcstorage",
//         accountkey:
//           "swGuYdk3eOgKPhi6ZHdwDzb5SeZBh9l3+hSdJ+RqOTYQ4YPLuisM8ZMykUpK/X2LkCFKDqxm7yndU5iasiJ/3Q==",
//       },
//       payload: container,
//     }
//   );
//   return data;
// };

export const firstApi = async () => {
  // const id = await getFromEncLocalStorage("accountId");
  // const key = await getFromEncLocalStorage("subKey");
  // const location = await getFromEncLocalStorage("location");
  // const data = await videoApi(
  //   `https://api.videoindexer.ai/Auth/${location}/Accounts/${id}/AccessToken?allowEdit=true`,
  //   {
  //     method: "GET",
  //     headers: {
  //       "Ocp-Apim-Subscription-Key": key,
  //     },
  //   }
  // );
  // return data;

  return "";
};

const videoProcessingStatus = {
  checkBigVideoFile: { status: "NOT_STARTED", retryCounter: 0 },
  fileConversion: { status: "NOT_STARTED", retryCounter: 0 },
  gcpUpload: { status: "NOT_STARTED", retryCounter: 0 },
};

export const uploadOnGCPVideoAudio = async (FileData, Progress) => {
  // Generate a random number between 0 and 9999 (inclusive)
  const randomNumber = Math.floor(Math.random() * 9999);
  let creator = getFromEncLocalStorage("userId");
  const formData = new FormData();
  let timestamp = Date.now();
  let fileName = "";
  if (FileData.name) {
    fileName = `${FileData.type.split("/")[0] + timestamp + creator + randomNumber
      }.${FileData.name.split(".")[1]}`;
  } else {
    fileName = `recording${timestamp + creator + randomNumber}.mp4`;
  }
  debugger;
  formData.append("file", FileData, fileName);
  try {
    // const response = await axios.post(
    //   uploadaudiovideo,
    //   formData,
    //   {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //     onUploadProgress: Progress,
    //   }
    // );
    const response = await axios.post(checkDoc, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        //Origin: Config.WEB_URL,
        "Permission-Policy": "microphone=(self) camera=(self)",
        "Cross-Origin-Embedder-Policy": "require-corp",
        "Cross-Origin-Opener-Policy": "same-origin",
        "Cross-Origin-Resource-Policy": "same-origin",
      },
      onUploadProgress: Progress,
    });
    // debugger;
    // if (typeof response?.data?.data === "string") {
    //   let decData = decryptV2(response?.data?.data);
    //   response.data = JSON.parse(decData);
    // }
    console.log("response: ", response?.data?.data);
    if (response && response.data && response.data.message == "Ok") {
      let newData = {
        data: {
          FileName: response?.data?.data?.FileName,
          DocumentType: response?.data?.data?.DocumentType,
          GlobalUrl: response?.data?.data?.GlobalUrl,
          DocValidationResponse: response?.data?.data,
        },
      };
      console.log("File uploaded successfully:", response);
      return newData;
    }
    console.error("Error uploading file:", response);
    //return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
  }
  return null;
};

export const uploadOnGCPVideoAudioNew = async (FileData, progressFn) => {
  // Generate a random number between 0 and 9999 (inclusive)
  const randomNumber = Math.floor(Math.random() * 9999);
  let creator = getFromEncLocalStorage("userId");
  const formData = new FormData();
  let timestamp = Date.now();
  let fileName = "";
  if (FileData.name) {
    fileName = `${FileData.type.split("/")[0] + timestamp + creator + randomNumber
      }.${FileData.name.split(".")[1]}`;
  } else {
    fileName = `recording${timestamp + creator + randomNumber}.mp4`;
  }
  formData.append("file", FileData, fileName);

  try {
    // // const response = await axios.post(
    // //   uploadaudiovideo,
    // //   formData,
    // //   {
    // //     headers: {
    // //       "Content-Type": "multipart/form-data",
    // //     },
    // //     onUploadProgress: Progress,
    // //   }
    // // );

    // const response = await axios.post(checkDoc, formData, {
    //   headers: {
    //     "Content-Type": "multipart/form-data",
    //     //Origin: Config.WEB_URL,
    //     "Permission-Policy": "microphone=(self) camera=(self)",
    //     "Cross-Origin-Embedder-Policy": "require-corp",
    //     "Cross-Origin-Opener-Policy": "same-origin",
    //     "Cross-Origin-Resource-Policy": "same-origin",
    //   },
    //   onUploadProgress: Progress,
    // });

    // // debugger;
    // // if (typeof response?.data?.data === "string") {
    // //   let decData = decryptV2(response?.data?.data);
    // //   response.data = JSON.parse(decData);
    // // }

    videoProcessingStatus.checkBigVideoFile.status = "NOT_STARTED";
    videoProcessingStatus.checkBigVideoFile.retryCounter = 0;
    videoProcessingStatus.fileConversion.status = "NOT_STARTED";
    videoProcessingStatus.fileConversion.retryCounter = 0;
    videoProcessingStatus.gcpUpload.status = "NOT_STARTED";
    videoProcessingStatus.gcpUpload.retryCounter = 0;

    const response = await resumableUpload(progressFn, FileData);
    console.log(
      "🚀 ~ file: CreateKnowledgeService.js:191 ~ uploadOnGCPVideoAudio ~ response:",
      response
    );

    if (response.message === "Ok") {
      progressFn(0, "Validation");
      const responseStartVideoProcessing = await startVideoProcessing(
        response.data,
        "checkBigVideoFile"
      );

      if (responseStartVideoProcessing) {
        let responseCheckVideoProcessingStatus =
          await checkVideoProcessingStatusWithInterval(
            response.data.fileName,
            progressFn,
            "Validation",
            "checkBigVideoFile"
          );

        if (responseCheckVideoProcessingStatus.done) {
          responseCheckVideoProcessingStatus.done = false;
          responseCheckVideoProcessingStatus.progress.percentage = 0;
          responseCheckVideoProcessingStatus.progress.percentageInt = 0;

          // progressFn(0, 'Conversion');
          // const responseStartVideoProcessing = await startVideoProcessing(response.data, "fileConversion");

          // if (responseStartVideoProcessing) {

          //   let responseCheckVideoProcessingStatus = await checkVideoProcessingStatusWithInterval(response.data.fileName, progressFn, 'Conversion', "fileConversion");

          //   if (responseCheckVideoProcessingStatus.done) {
          //     responseCheckVideoProcessingStatus.done = false;
          //     responseCheckVideoProcessingStatus.progress.percentage = 0;
          //     responseCheckVideoProcessingStatus.progress.percentageInt = 0;
          progressFn(0, "Storage");
          const responseStartVideoStorage = await startVideoProcessing(
            response.data,
            "gcpUpload",
            responseCheckVideoProcessingStatus.progress
          );

          if (responseStartVideoStorage) {
            responseCheckVideoProcessingStatus =
              await checkVideoProcessingStatusWithInterval(
                response.data.fileName,
                progressFn,
                "Storage",
                "gcpUpload"
              );

            if (responseCheckVideoProcessingStatus.done) {
              if (responseCheckVideoProcessingStatus?.progress?.data) {
                let gcpData =
                  responseCheckVideoProcessingStatus?.progress?.data;
                let newData = {
                  data: {
                    FileName: gcpData?.FileName,
                    DocumentType: gcpData?.DocumentType,
                    GlobalUrl: gcpData?.GlobalUrl,
                    DocValidationResponse: gcpData,
                  },
                };

                console.log("File uploaded successfully:", response);
                return newData;
              }
            }
          }
          //   }
          // }
        }
      }
    } else {
      return null;
    }

    console.error("Error uploading file:", response);
    //return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
  }
  return null;
};

const resumableUpload = async (progressFn, FileData) => {
  return new Promise((resolve, reject) => {
    // Simulate an asynchronous operation
    try {
      //resumable.upload();

      const resumable = new Resumable({
        target: uploadBigVideo, // Express.js backend URL
        chunkSize: 50 * 1024 * 1024, // 50MB chunk size
        forceChunkSize: true,
        query: { upload_token: moment().format("YYYYMMDD_HHmmss") }, // Additional query parameters
        maxFiles: 1,
        testChunks: false, // Skip chunk existence checks
        simultaneousUploads: 1,
        withCredentials: true,
        setChunkTypeFromFile: true,
        headers: {
          "Access-Control-Allow-Origin": "SAMEORIGIN",
          "Access-Control-Allow-Headers": "*",
        },
      });

      resumable.on("fileAdded", (file) => {
        const timestamp = moment().format("YYYYMMDD_HHmmss");
        const fileNameWithoutExtension = file?.fileName
          ?.replace(/\s+/g, "_")
          ?.split(".")
          ?.slice(0, -1)
          ?.join(".");
        const fileExtension = file.fileName.split(".").pop();

        // Append timestamp to filename
        const newFileName = `${fileNameWithoutExtension}_${timestamp}.${fileExtension}`;

        // Set the new filename in the Resumable file object
        file.fileName = newFileName;

        resumable.upload();
      });

      resumable.on("fileProgress", (file) => {
        const percentage = Math.floor(file.progress() * 100);
        progressFn(percentage, "Upload");
      });

      resumable.on("fileSuccess", (file, message) => {
        console.log("File successfully uploaded:", file);
        progressFn(100, "Upload");
        resolve(JSON.parse(message));
      });

      resumable.on("fileError", (file, message) => {
        console.error("Error uploading file:", file, message);
        reject(message);
      });

      resumable.addFile(FileData);
    } catch (error) {
      reject("An error occurred: " + error);
    }
  });
};

const startVideoProcessing = async (
  documentName,
  type,
  lastProgressObj = null
) => {
  let requestParams = {
    document: documentName,
    type: type,
  };
  if (lastProgressObj) {
    documentName.hlsStreams = lastProgressObj?.data;
  }
  videoProcessingStatus[type].status = "IN_PROGRESS";
  videoProcessingStatus[type].retryCounter =
    videoProcessingStatus[type].retryCounter + 1;
  const resp = await APICall(startVideoProcess, requestParams);

  if (resp?.message == "Ok" && resp?.data?.started) {
    videoProcessingStatus[type].status = "DONE";
    return true;
  }
  videoProcessingStatus[type].status = "FAILED";
  if (videoProcessingStatus[type].retryCounter < 5) {
    return startVideoProcessing(documentName, type, lastProgressObj);
  }

  return false;
};

const checkVideoProcessingStatus = async (documentName, type) => {
  try {
    let requestParams = {
      documentId: documentName,
      type: type,
    };
    const resp = await APICall(conversionProgress, requestParams);

    if (resp?.error === false) {
      return resp?.progress;
    }
  } catch (err) {
    console.log(
      "🚀 ~ file: CreateKnowledgeService.js:350 ~ checkVideoProcessingStatus ~ err:",
      err
    );
  }

  return false;
};

const checkVideoProcessingStatusWithInterval = async (
  documentName,
  progressFn,
  label,
  type
) => {
  let a = true;
  let sleepTimer = type === "fileConversion" ? 10 : 5;
  while (a) {
    await sleep(sleepTimer * 1000); //5 seconds

    const progress = await checkVideoProcessingStatus(documentName, type);

    if (
      progress?.percentageInt &&
      progress?.percentageInt > -1 &&
      type === progress?.type
    ) {
      progressFn(progress.percentageInt, label);
    }
    if (progress.percentage >= 90 && type === "fileConversion") {
      sleepTimer = 5;
    }
    if (progress.percentage >= 100 && type === progress?.type) {
      return { done: true, progress };
    }
  }
};

export const uploadVideo = async (token, formData, fileName) => {
  // console.log("Upload Video File: ");
  // console.log("token: ", token);
  // console.log("formData: ", formData);
  // console.log("fileName: ", fileName);

  const id = await getFromEncLocalStorage("accountId");
  const location = await getFromEncLocalStorage("location");
  const data = await videoApi(
    `https://api.videoindexer.ai/${location}/Accounts/${id}/Videos?accessToken=${token}&name=${fileName}&privacy=public&partition=some_partition`,
    {
      method: "POST",
      payload: formData,
      isFormData: true,
    }
  );
  console.log("Video data: ", data);

  return data;
};

export const getVideoDetails = async (token, videoId) => {
  // console.log("getVideoDetails token: ", token);
  // console.log("getVideoDetails videoId: ", videoId);
  const id = getFromEncLocalStorage("accountId");
  const location = getFromEncLocalStorage("location");

  // console.log("getVideoDetails localStorage location: ", location);
  // console.log("getVideoDetails localStorage id: ", id);

  let data = await videoApi(
    `https://api.videoindexer.ai/${location}/Accounts/${id}/Videos/Search?accessToken=${token}&&id=${videoId}`,
    {
      method: "GET",
    }
  );
  // if (data && data?.hasOwnProperty("results") && data.results.length == 0) {
  //   console.log("In data==[] part");
  //   await sleep(3000);
  //   data = await getVideoDetails(token, videoId);
  // }
  return data;
};

export const getVideoDetails1 = async (token, fileName, videoId) => {
  // console.log("getVideoDetails token: ", token);
  // console.log("getVideoDetails videoId: ", videoId);
  const id = getFromEncLocalStorage("accountId");
  const location = getFromEncLocalStorage("location");

  let data = await videoApi(
    `https://api.videoindexer.ai/${location}/Accounts/${id}/Videos?accessToken=${token}&name=${fileName}&privacy=public&partition=some_partition&sourceVideoId=${videoId}`,
    {
      method: "GET",
    }
  );
  // if (data && data?.hasOwnProperty("results") && data.results.length == 0) {
  //   console.log("In data==[] part");
  //   await sleep(3000);
  //   data = await getVideoDetails(token, videoId);
  // }
  return data;
};

export const getVideoToken = async (videoId) => {
  const id = getFromEncLocalStorage("accountId");
  const key = getFromEncLocalStorage("subKey");
  const location = getFromEncLocalStorage("location");
  const data = await videoApi(
    `https://api.videoindexer.ai/Auth/${location}/Accounts/${id}/Videos/${videoId}/AccessToken?allowEdit=true`,
    {
      method: "GET",
      headers: {
        "Ocp-Apim-Subscription-Key": key,
      },
    }
  );
  return data;
};

export const getVideoDownloadUrl = async (videoId, vtoken) => {
  const id = await getFromEncLocalStorage("accountId");
  const location = await getFromEncLocalStorage("location");
  const data = await videoApi(
    `https://api.videoindexer.ai/${location}/Accounts/${id}/Videos/${videoId}/SourceFile/DownloadUrl?accessToken=${vtoken}`,
    {
      method: "GET",
    }
  );
  return data;
};

export const getTranscription = async (videoId, token) => {
  const id = await getFromEncLocalStorage("accountId");
  const location = await getFromEncLocalStorage("location");
  const data = await videoApi(
    `https://api.videoindexer.ai/${location}/accounts/${id}/videos/${videoId}/Index/?language=en-US&accessToken=${token}`,
    {
      method: "GET",
    }
  );
  return data;
};

const CreateKnowledgeService = {
  createKnowledge,
  fileUpload,
  // getFile,
  firstApi,
  uploadVideo,
  uploadOnGCPVideoAudio,
  getVideoDetails,
  getVideoDetails1,
  getVideoToken,
  getTranscription,
  getVideoDownloadUrl,
  uploadOnGCPVideoAudioNew,
};
export default CreateKnowledgeService;
